import { Grid } from "@mui/material"
import { toDataCy } from "lib/to-data-cy"
import AppWidget from "minimals-template/pages/sections/@dashboard/general/app/AppWidget"
import uniqolor from "uniqolor"

export function Summary({ item: [name, list], total, setFilter, current }) {
    const selected = current === name
    const active = !current || selected
    const opacity = active ? 1 : 0.4
    const percentage = Math.floor((list.length / (total || Infinity)) * 100)

    return (
        <Grid item xs={12} md={6} lg={4}>
            <AppWidget
                sx={{ cursor: "pointer", opacity }}
                role="button"
                className={name.replace(/\W+/gi, "-")}
                data-cy={toDataCy("recycle-bin-summary", name)}
                aria-label={name}
                onClick={() => setFilter(name)}
                title={name.pluralize(list.length)}
                color={uniqolor(name).color}
                total={list.length}
                icon={list[0].icon}
                chartData={{
                    series: [percentage],
                }}
            />
        </Grid>
    )
}
